jQuery(document).ready(function ($) {

    var Headsinhelmet = (function () {

        var customSameHeight = function () {

            enquire.register("screen and (min-width: 1199px)", {
                match: function () {

                    if( $('.product-img-wrap').length > 0 ) {
                        $('.product-img-wrap').matchHeight();
                    }

                },
                unmatch: function () {
                }
            });

            enquire.register("screen and (min-width: 768px)", {
                match: function () {

                    $('#main-menu > li.dropdown').on('click', function() {
                        var $el = $(this);

                        var $a = $el.children('a.dropdown-toggle');
                        if ($a.length && $a.attr('href')) {
                            location.href = $a.attr('href');
                        }

                    });

                },
                unmatch: function () {
                }
            });

            enquire.register("screen and (min-width: 992px)", {
                match: function () {

                    if( $('.sameColHeight').length > 0 ) {
                        $('.sameColHeight').matchHeight();
                    }

                },
                unmatch: function () {

                }
            });

            enquire.register("screen and (max-width: 991px)", {
                match: function () {

                    if( $('.product-img-wrap.sameColHeight').length > 0 ) {
                        $('.home .product-img-wrap.sameColHeight').matchHeight();
                    }

                },
                unmatch: function () {

                }
            });

        };

        var smoothScroll = function () {

            if( $('.contents-table').length > 0 ) {
                $('.contents-table').smoothScroll();
            }

            if( $('.back-to-top-wrap').length > 0 ) {
                $('.back-to-top-wrap').smoothScroll();
            }

        };

        var slickSlider = function () {

            $('.awards-list').slick(
                {
                    dots: false,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    prevArrow: '<i class="fa fa-caret-left" aria-hidden="true"></i>',
                    nextArrow: '<i class="fa fa-caret-right" aria-hidden="true"></i>',
                    appendArrows: '.slick-nav-awards',
                    responsive: [
                        {
                            breakpoint: 1199,
                            settings: {
                                dots: false,
                                infinite: true,
                                speed: 300,
                                slidesToShow: 4,
                                slidesToScroll: 4
                            }
                        },
                        {
                            breakpoint: 991,
                            settings: {
                                dots: false,
                                infinite: true,
                                speed: 300,
                                slidesToShow: 3,
                                slidesToScroll: 3
                            }
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                dots: false,
                                infinite: true,
                                speed: 300,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                centerMode: true
                            }
                        }
                        // You can unslick at a given breakpoint now by adding:
                        // settings: "unslick"
                        // instead of a settings object

                    ]
                }
            );

            enquire.register("screen and (max-width: 767px)", {
                match: function () {

                    if( $('.home .products-showcase').length > 0 ) {

                        $('.home .products-showcase .products').slick(
                            {
                                dots: false,
                                infinite: true,
                                speed: 300,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                prevArrow: '<i class="fa fa-caret-left" aria-hidden="true"></i>',
                                nextArrow: '<i class="fa fa-caret-right" aria-hidden="true"></i>',
                                appendArrows: '.slick-nav-products',
                                centerMode: true
                            }
                        );
                    }

                },
                unmatch: function () {

                }
            });

        };

        var videoModal = function () {

            $("#homeVideo").on('shown.bs.modal', function (e) {
                $('#video-5-1_html5').trigger('play');
            });

            $("#homeVideo").on('hidden.bs.modal', function (e) {
                $('#video-5-1_html5').trigger('pause');
            });

        };

        var initVideoAccordion = function () {

            $('#interview-youtube a.video-link').click(function (e) {
                e.preventDefault;

                $videoTitle = $(this).text();

                $('.video-title').text('');
                $('.video-title').text($videoTitle);

                $('#interview-youtube a.video-link').removeClass('active');
                $(this).addClass('active');

                var id = $(this).attr('data-youtube');
                var src = '//www.youtube.com/embed/' + id;
                var iframe = '<iframe id="youtube" width="560" height="315" frameborder="0" src="' + src + '" allowfullscreen></iframe>';
                $("#interview-youtube .playlist-video-wrap").addClass('active').html(iframe);
                return false;
            });

            var counter = 0;

            $('#interview-youtube .video-wrap').on('click', function () {

                var that = this;

                var video_src = '';
                var video_src_play = '';
                var video_src = $(this).find('.cw_video_single').attr('src');

                if (counter == 0) {
                    video_src_play = $(this).find('.cw_video_single').attr('src') + 1;
                }
                ;

                counter = 1;

                $(that).find('.cw_video_single').attr('src', video_src_play);

                $(that).find('.img-poster').fadeOut('slow');
                $(that).find('.btn-play').fadeOut('slow');

            });

            $('.accordion-interviews a.video-link').click(function () {

                $('.accordion-interviewsa.video-link').removeClass('active');
                $(this).addClass('active');

                var id = $(this).attr('data-youtube');
                var src = '//www.youtube.com/embed/' + id;
                var iframe = '<iframe id="youtube" width="560" height="315" frameborder="0" src="' + src + '" allowfullscreen></iframe>';
                $(".accordion-interviews .playlist-video-wrap").addClass('active').html(iframe);
                return false;
            });

            var counter = 0;

            $('.accordion-interviews .video-wrap').on('click', function () {

                var that = this;

                var video_src = '';
                var video_src_play = '';
                var video_src = $(this).find('.cw_video_single').attr('src');

                if (counter == 0) {
                    video_src_play = $(this).find('.cw_video_single').attr('src') + 1;
                };

                counter = 1;

                $(that).find('.cw_video_single').attr('src', video_src_play);

                $(that).find('.img-poster').fadeOut('slow');
                $(that).find('.btn-play').fadeOut('slow');

            });

        };

        var faqs = function () {

            $('.qa-faqs h3 a').on('click', function (event) {
                event.preventDefault();
                $(this).stop().toggleClass('active');
                $(this).parent().toggleClass('open');

            });


            if( $('.post-type-archive-result').length > 0 ) {
                $('.post-type-archive-result .breadcrumb_last').text('Verdicts & Results');
            }

        };

        var initialSettings = function () {

            jQuery(window).load(function() {

                if( $('.woocommerce-pagination').length > 0 ) {
                    $('.woocommerce-pagination .next').html('<i class="fa fa-chevron-right">');
                    $('.woocommerce-pagination .prev').html('<i class="fa fa-chevron-left">');
                }

                $event_title = $('.single-tribe_events .tribe-events-single-event-title').html();

                if( $('.single-tribe_events').length > 0 ) {
                    $('.breadcrumb > span > span').append('<span>' + $event_title + '</span>');
                }

                if( $('.woocommerce-pagination').length > 0 ) {
                    $('.page-numbers.current').parent().addClass('active');
                }

                $('#tribe-events-bar > form').attr('id','tribe-bar-form');

                if( $('.button.product_type_simple.add_to_cart_button.ajax_add_to_cart').length > 0 ) {
                    $(".button.product_type_simple.add_to_cart_button.ajax_add_to_cart").addClass('btn');
                }

                if( $('.related.products .product-img-wrap').length > 0 ) {
                    $(".related.products .product-img-wrap").matchHeight();
                }

                enquire.register("screen and (max-width: 1199px)", {
                    match: function () {
                        if( $('.woocommerce-LoopProduct-link .product-img-wrap').length > 0 ) {
                            $(".woocommerce-LoopProduct-link .product-img-wrap").matchHeight();
                        }
                    },
                    unmatch: function () {
                    }
                });

            });

        };

        var mobileNav = function () {

            enquire.register("screen and (max-width: 767px)", {
                match: function () {

                    $('ul.main-nav > li.dropdown > a').on('click', function (e) {
                        e.preventDefault();
                        $(this).next().slideToggle().toggleClass('open');
                    });

                    $('ul.main-nav > li.dropdown > ul.dropdown-menu > li.dropdown > a').on('click', function (e) {
                        e.preventDefault();
                        $(this).next().slideToggle().toggleClass('open');
                    });

                },
                unmatch: function () {

                }
            });

            $('.nav-opener').on('click',function () {
                var overlay = document.querySelector("body");
                overlay.classList.toggle('hide-overlay');
            });

            $('.nav-opener').on('click', function () {
                $(this).toggleClass('active');
            });

        };


        var stickyMenu = function () {

            var sticky = new Waypoint.Sticky(
                {
                    element: $('#main-menu-wrap-sticky')
                }
            );

        };

        return {

            init: function () {
                initialSettings();
                smoothScroll();
                slickSlider();
                customSameHeight();
                videoModal();
                initVideoAccordion();
                faqs();
                mobileNav();
                stickyMenu();
            }

        }

    })();

    Headsinhelmet.init();

});